import React from 'react';

const PSAudio: React.FC = ({ children }) => {
    return (
        <audio controls onContextMenu={() => false} controlsList="nodownload" preload="none">
            {children}
            Ваш браузер не поддерживает элемент <code>audio</code>.
        </audio>
    );
};

export default PSAudio;
